import React from "react";
import { LL0 } from "@/react/core/I18nService.tsx";
import _ from "lodash";
import dayjs from "dayjs";
import { LL2 } from "@/react/core/I18nBackend.tsx";
import { users0 } from "@/data/UserSignal.ts";

const MenuDetailCard = ({ order,  }) => {
  // console.log(`render detail order ${order._id}`)
  return (
    <div className="shadow-[0px_4px_10px_rgba(0,_0,_0,_0.2)] min-w-[350px] rounded-[8px] bg-[#fff] border-[#2979ff] border-[1px] border-solid flex flex-col items-start justify-center p-[16px] gap-[8px] z-[0] relative">
      <button
        className="hidden absolute top-1 right-1 text-red-500 text-sm"
        // onClick={onClose}
      >
        ❌
      </button>
      <div className="flex flex-col items-start justify-start gap-[8px]">
        <div className="flex flex-row items-start justify-start gap-[16px]">
          <div className="self-stretch w-[160px] flex flex-col items-start justify-between min-w-[164px]">
            <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
              <img className="w-[20px] h-[20px] object-cover" alt="" src="/iconorder@2x.png" />
              <div className="font-medium">{order.customerRaw.note}</div>
            </div>
            <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
              <img className="w-[20px] h-[20px] object-cover" alt="" src="/iconuser@2x.png" />
              <div className="font-medium">{order.customerRaw.name}</div>
            </div>
            <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
              <img className="w-[20px] h-[20px] object-cover" alt="" src="/iconphone@2x.png" />
              <div className="font-medium">{order.customerRaw.phone}</div>
            </div>
          </div>
          {order.driverInfo && <div
            className="w-[140px] rounded-[6px] bg-[#f3fcff] border-[#2979ff] border-[1px] border-dashed box-border flex flex-col items-start justify-start py-[8px] px-[10px] gap-[6px] text-[#2979ff]">
            <div className="flex flex-row items-center justify-start text-[#cf24e5]">
              <b className="relative">{users0().find(u => u._id === order.driverInfo._id)?.name}</b>
            </div>
            <b
              className="relative">{dayjs.unix(order?.startAt).format(LL2().dates.timeFormat())}, {dayjs.unix(order?.startAt).format(LL2().dates.dateFormat())}</b>
            <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
              <img
                className="w-[20px] relative h-[20px] object-cover"
                alt=""
                src="/icontime@2x.png"
              />
              <b className="relative">{dayjs(order.pickupDate).diff(dayjs(), 'minutes')} mins left</b>
            </div>
          </div>}
        </div>
        <div className="self-stretch flex flex-row items-start justify-start pt-[4px] px-[0px] pb-[0px] gap-[4px] text-left">
          <img className="w-[20px] h-[20px] object-cover" alt="" src="/iconhome-location1@2x.png" />
          <div className="flex-1 font-medium">
            <p className="m-[0px]">{order.customerRaw.address}</p>
          </div>
        </div>
      </div>
      <div className="self-stretch bg-[#e0e0e0] h-[1px]" />
      <div className="self-stretch flex flex-col items-start justify-start gap-[2px] text-[18px]">
        <div className="self-stretch flex flex-row items-center justify-center gap-[4px]">
          <img className="w-[28px] h-[28px] object-cover" alt="" src="/iconcash1@2x.png" />
          <b>{`$${order.vSum}`}</b>
        </div>
        <div className="text-center self-stretch text-[14px] font-semibold text-[#ff9811] overflow-hidden text-ellipsis whitespace-nowrap sm:text-[13px] mq768:text-[13px] mq600:text-[12px]">
          {_.get(LL0().delivery.deliveryStatus2, order.deliveryStatus)?.()}
        </div>
      </div>
    </div>
  );
};

export default MenuDetailCard;
